<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12"> 
        <div class="card">
          <div class="card-header border-bottom">
            <div class="user d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Customers</h5>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table id="datatable-search" class="table table-flush table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="users.length === 0">
                  <td colspan="5" class="text-center">No users found.</td>
                </tr>
                <tr v-for="user in users" :key="user.id">
                  <td>{{ user.name }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.status }}</td>
                  <td>{{ formatDate(user.created_at) }}</td>
                  <td>
                    <button @click="editUser(user.id, user.email)" class="btn btn-primary btn-sm">Edit</button>
                    <button @click="viewCallLogs(user)" class="btn btn-info btn-sm">
                      <i class="fas fa-phone"></i> View Calls
                    </button>
                    <button v-if="user.status === 'Inactive'" @click="enableUser(user.id)" class="btn btn-success btn-sm">Enable</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import userService from "@/services/users.service";
import Swal from 'sweetalert2';

export default {
  name: 'CustomerList',
  data() {
    return {
      users: [],
      dataTable: null,
    };
  },

  async mounted() {
    await this.fetchUsers();
  },

  methods: {
    async fetchUsers() {
      try {
        const response = await userService.getCustomers();
        this.users = response;
        console.log('=== CUSTOMERS LOADED ===');
        console.log('Number of customers:', this.users.length);
        this.initializeDataTable();
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString();
    },

    editUser(userId, email) {
      console.log('=== EDIT USER CALLED ===');
      console.log('UserID:', userId, 'Email:', email);
      
      if (!userId) {
        console.error('ERROR: userId is missing!');
        alert('Error: User ID is missing');
        return;
      }
      
      if (!email) {
        console.error('ERROR: email is missing!');
        alert('Error: Email is missing');
        return;
      }

      const dataObject = { userId, email };
      const jsonString = JSON.stringify(dataObject);
      const encodedData = btoa(jsonString);
      
      this.$router.push({ name: 'EditCustomer', params: { id: encodedData } });
    },

    // NEW: View Call Logs for a customer - using query params
    viewCallLogs(user) {
      console.log('=== VIEW CALL LOGS CALLED ===');
      console.log('User:', user);
      
      if (!user.id) {
        console.error('ERROR: userId is missing!');
        Swal.fire('Error', 'User ID is missing', 'error');
        return;
      }

      // Navigate with query parameters (cleaner URLs and easier debugging)
      this.$router.push({ 
        name: 'AdminCallLogs', 
        query: { 
          userId: user.id,
          name: user.name,
          email: user.email
        } 
      });
    },

    async enableUser(userId) {
      console.log('=== ENABLE USER CALLED ===');
      console.log('UserID:', userId);
      
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to enable this customer?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, enable!',
      });

      if (result.isConfirmed) {
        try {
          await userService.enableUser(userId);

          const user = this.users.find(user => user.id === userId);
          if (user) {
            user.status = 'Active';
          }

          this.refreshDataTable();

          Swal.fire('Enabled!', 'The customer has been enabled.', 'success');
        } catch (error) {
          console.error(`Error enabling user with ID: ${userId}`, error);
          Swal.fire('Error!', 'There was an error enabling the user. Please try again.', 'error');
        }
      }
    },

    initializeDataTable() {
      this.$nextTick(() => {
        if ($.fn.DataTable.isDataTable('#datatable-search')) {
          $('#datatable-search').DataTable().destroy();
        }

        this.dataTable = $('#datatable-search').DataTable({
          paging: true,
          searching: true,
          info: true,
          data: this.users,
          columns: [
            { data: 'name' },
            { data: 'email' },
            { data: 'status' },
            {
              data: 'created_at',
              render: data => this.formatDate(data)
            },
            {
              data: null,
              render: (data, type, row) => {
                const editBtn = `<button class='btn btn-primary btn-sm edit-btn' data-id='${row.id}' data-email='${row.email}'>Edit</button>`;
                const viewCallsBtn = ` <button class='btn btn-info btn-sm view-calls-btn' data-id='${row.id}' data-email='${row.email}' data-name='${row.name}'><i class='fas fa-phone'></i> View Calls</button>`;
                const enableBtn = row.status === 'Inactive'
                  ? ` <button class='btn btn-success btn-sm enable-btn' data-id='${row.id}'>Enable</button>`
                  : '';
                return editBtn + viewCallsBtn + enableBtn;
              }
            }
          ],
          createdRow: (row, data) => {
            // Edit button click handler
            $(row).find('.edit-btn').on('click', (e) => {
              const userId = $(e.target).data('id');
              const email = $(e.target).data('email');
              this.editUser(userId, email);
            });

            // View Calls button click handler
            $(row).find('.view-calls-btn').on('click', (e) => {
              const btn = $(e.target).closest('button');
              const userId = btn.data('id');
              const email = btn.data('email');
              const name = btn.data('name');
              this.viewCallLogs({ id: userId, email: email, name: name });
            });

            // Enable button click handler
            if (data.status === 'Inactive') {
              $(row).find('.enable-btn').on('click', (e) => {
                const userId = $(e.target).data('id');
                this.enableUser(userId);
              });
            }
          },
          drawCallback: () => {
            this.applyCustomBorders();
          }
        });
      });
    },

    refreshDataTable() {
      if (this.dataTable) {
        this.dataTable.clear().rows.add(this.users).draw();
      }
    },

    applyCustomBorders() {
      $('#datatable-search th, #datatable-search td').css({
        'border': '1px solid #ddd',
        'padding': '10px',
      });

      $('#datatable-search td:first-child, #datatable-search th:first-child').css({
        'border-left': '2px solid #ddd',
      });

      $('#datatable-search th').css({
        'border-top': '2px solid #ddd',
      });
    },
  },
};
</script>

<style scoped>
#datatable-search {
  table-layout: fixed;
  width: 100%;
}

#datatable-search th, #datatable-search td {
  border: 1px solid #ddd !important;
  padding: 10px;
}

#datatable-search td:first-child, #datatable-search th:first-child {
  border-left: 2px solid #ddd !important;
}

#datatable-search th {
  border-top: 2px solid #ddd !important;
}

#datatable-search td button {
  margin-right: 5px;
  margin-bottom: 3px;
}

.btn-info {
  color: white;
}
</style>